import {Component, ElementRef, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import { OptionService } from "../option/option.service";
import { Donation } from "../donation/donation";

@Component({
    selector: 'amount-image',
    templateUrl: './amount.image.component.html'
})
export class AmountImageComponent implements OnInit {
    /**
     * The current donation object
     */
    @Input() donation: Donation;

    /**
     * DOM element of the image-wrapper
     */
    @ViewChild('imageWrapper') imageWrapper: ElementRef;

    /**
     * Should the element be visible or not
     */
    amountImages: any = [];

    /**
     * Holds the image directory of the prject/organisation
     */
    imageDirecory: string;

    /**
     * The minimum value from which one the element should be visible.
     */
    minimumValue: number = 0;

    /**
     * The constructor
     * @param {OptionService} optionService
     */
    constructor(private optionService: OptionService) {}

    /**
     * will be called after first image is loaded and on widow resize (for rotating mobile devices)
     */
    @HostListener('window:resize')
    onImageLoad() {
      if (this.amountImages && this.imageWrapper?.nativeElement) {
        // set style.max-height of image-wrapper to height if first image
        (this.imageWrapper.nativeElement as HTMLElement).style['max-height'] = ((this.imageWrapper.nativeElement as HTMLElement).children[0] as HTMLImageElement).height + 'px';
      }
    }

    /**
     * Initialize the slider
     */
    public ngOnInit(): any {
        // get/check if we have amount images saved on the project
        let amountImages = this.optionService.getOption('amount_images');

        if(amountImages && typeof amountImages === 'object' && amountImages.length > 0) {
            this.amountImages = amountImages;
            this.minimumValue = amountImages[0].minimum;
            this.imageDirecory = this.optionService.getImageDirectory();

            if(this.imageDirecory.length === 0) {
                console.error("Could not get image directory");
            }
        }
    }
}
